import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const container = style({
    marginBottom: 15
})

export const title = style({
    padding: '13px 15px',
    fontSize: 18,
    color: '#000000',
    textAlign: 'left',
    display: 'flex',
    ...csstips.flexRoot,
    ...csstips.betweenJustified
})

export const bold = style({
    fontWeight: 'bold'
})

export const right = style({
    fontSize: 14,
    color: '#999999',
    textAlign: 'right',
    cursor: 'pointer',
    display: 'flex',
    ...csstips.flexRoot,
    ...csstips.center
})

export const arrow = style({
    borderLeft: '2px solid #ccc',
    borderTop: '2px solid #ccc',
    display: 'inline-block',
    height: '8px',
    width: '8px',
    transform: 'rotate(135deg)'
})

export const list = style({
    width: 'calc(100% - 30px)',
    background: '#fff',
    margin: '0 15px',
    boxSizing: 'border-box',
    borderRadius: 10
})

export const listItem = style({
    width: '100%',
    padding: '15px 15px',
    backgroundColor: 'white',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    ...csstips.flexRoot
})

export const leftSide = style({
    marginRight: '10px'
})

export const thumb = style({
    width: '120px',
    height: '68px',
    position: 'relative',
    overflow: 'hidden',
    borderTopRightRadius: '5px',
    borderTopLeftRadius: '5px'
})
export const channelName = style({
    'fontSize': '16px',
    'color': '#333333',
    'maxHeight': '36px',
    'fontWeight': 500,
    'display': '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    'overflow': 'hidden'
})

export const rightSide = style({
    width: 'calc(100% - 130px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
})

export const bottom = style({
    fontSize: '12px',
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '16px',
    display: 'flex',
    ...csstips.flexRoot,
    ...csstips.betweenJustified
})

export const bottomLeftItem = style({
    fontSize: '12px',
    marginTop: 5,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '16px',
    flex: 1,
    textAlign: 'center'
})

export const bottomMiddleItem = style({
    fontSize: '12px',
    marginTop: 5,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '16px',
    flex: 1
})

export const bottomRightItem = style({
    fontSize: '12px',
    marginTop: 5,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '16px',
    flex: 1,
    textAlign: 'right'
})

export const currentPrice = style({
    fontSize: '14px',
    color: '#F44336',
    lineHeight: '18px',
    fontWeight: 'bold'
})

export const currentPriceDot = style({
    fontSize: '12px',
    color: '#F44336',
    lineHeight: '18px',
    fontWeight: 'bold'
})

export const sourcePrice = style({
    fontSize: '12px',
    color: '#999999',
    textDecoration: 'line-through'
})



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/Channel/Channel.style.ts